import { SelectItem } from "primereact/selectitem";
import { T } from "services/lang/LanguageService";

// eslint-disable-next-line import/prefer-default-export
export const textAligns: SelectItem[] = [
  { label: T("word.left"), value: "left" },
  { label: T("layout.center"), value: "center" },
  { label: T("word.right"), value: "right" },
] as const;
